/* Atomz app slot - the theme's chat tile, inside the app's own product grid.
 *
 * THE PROBLEM: on a collection the theme draws the cards, so the tile is one
 * more cell in the theme's loop. On search it cannot be. The app owns the
 * grid there and the theme's results body renders no cards at all, so the loop
 * that would place the tile never runs. Switching the setting on did nothing
 * at all, on a page where a shopper who has not found it is most likely to be.
 *
 * WHAT IT DOES: takes the live tile the section rendered outside the grid and
 * puts it in the app's #az-product-grid at the same index the theme would have
 * used. Moved, never copied: the tile is wired to the chat SDK and a copy of
 * its markup would be a picture of a tile.
 *
 * WHY IT KEEPS WATCHING: the app rebuilds its grid from scratch on every
 * search, every filter and every page of results, which throws the tile out
 * with the old cards. The observer puts it back each time rather than trusting
 * one insertion to hold.
 *
 * FAILURE MODE: no holder or no grid and nothing happens; the page is the page
 * it was. The tile is only ever shown once it is in the grid, so a failure
 * leaves it hidden rather than stranded above the results.
 */
(function () {
  'use strict';

  if (!/\/search/.test(window.location.pathname)) return;

  function grid() {
    return document.getElementById('az-product-grid') ||
           document.querySelector('.az-product-grid');
  }

  function cards(g) {
    /* The app keeps empty cards in the DOM as its template, and the tile
       itself is a child once it is in. Neither is a product. */
    return Array.prototype.filter.call(g.children, function (el) {
      return el !== tile && el.querySelector && el.querySelector('.az-product-card-link[href]');
    });
  }

  var holder = document.querySelector('[data-az-appslot]');
  var tile = holder && holder.querySelector('.az-card--slot');
  if (!tile) return;

  var at = parseInt(holder.getAttribute('data-az-appslot-at'), 10);
  if (!(at >= 0)) at = 0;

  function place() {
    var g = grid();
    if (!g) return;

    var list = cards(g);

    /*
     * Not placed at all until there is a full row after it. A tile sitting in
     * the last cell of a short result reads as a product the shopper does not
     * have, and on one row it pushes a real result off the screen.
     */
    if (list.length < at + 4) {
      if (tile.parentNode === g) g.removeChild(tile);
      tile.hidden = true;
      return;
    }

    var before = list[at] || null;
    if (tile.parentNode === g && tile.nextElementSibling === before) {
      tile.hidden = false;
      return;
    }

    g.insertBefore(tile, before);
    tile.hidden = false;
  }

  var timer;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(place, 60);
  }

  function watch() {
    var g = grid();
    if (!g) return false;
    /* On the grid's children only. Watching the subtree would fire on every
       image the app swaps inside a card. */
    new MutationObserver(schedule).observe(g, { childList: true });
    schedule();
    return true;
  }

  if (!watch()) {
    var boot = new MutationObserver(function () {
      if (watch()) boot.disconnect();
    });
    boot.observe(document.documentElement, { subtree: true, childList: true });
  }
})();
